import map from 'lodash/map';
export const _map = map;
